var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBike2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 312,
    height: 42,
    viewBox: "0 0 312 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 36.8096H44.7619V41.2858H0V36.8096Z",
    fill: "#FBA819"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1406 4.47619C38.1406 2.01428 36.2222 0 33.8775 0H27.483V4.47619H33.8775V10.4071L26.4599 20.1428H18.9569V8.95237H10.4309C5.7202 8.95237 1.90479 12.9586 1.90479 17.9047V24.619H6.16782C6.16782 28.3343 9.02405 31.3333 12.5624 31.3333C16.1007 31.3333 18.9569 28.3343 18.9569 24.619H28.5061L38.1406 11.9738V4.47619ZM6.16782 20.1428V17.9047C6.16782 15.4428 8.08618 13.4286 10.4309 13.4286H14.6939V20.1428H6.16782ZM12.5624 26.8571C11.39 26.8571 10.4309 25.85 10.4309 24.619H14.6939C14.6939 25.85 13.7347 26.8571 12.5624 26.8571Z",
    fill: "#3E3E3E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29895 2.23804H18.9565V6.71422H8.29895V2.23804ZM38.1402 17.9047C34.6019 17.9047 31.7456 20.9037 31.7456 24.619C31.7456 28.3342 34.6019 31.3333 38.1402 31.3333C41.6785 31.3333 44.5347 28.3342 44.5347 24.619C44.5347 20.9037 41.6785 17.9047 38.1402 17.9047ZM38.1402 26.8571C36.9679 26.8571 36.0087 25.8499 36.0087 24.619C36.0087 23.388 36.9679 22.3809 38.1402 22.3809C39.3125 22.3809 40.2717 23.388 40.2717 24.619C40.2717 25.8499 39.3125 26.8571 38.1402 26.8571Z",
    fill: "#3E3E3E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 4,
    transform: "matrix(-1 0 0 1 13 37.2856)",
    fill: "#FBA819"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 4,
    transform: "matrix(-1 0 0 1 105 37.2856)",
    fill: "#FBA819",
    fillOpacity: 0.7
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 4,
    transform: "matrix(-1 0 0 1 197 37.2856)",
    fill: "#FBA819",
    fillOpacity: 0.3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 4,
    transform: "matrix(-1 0 0 1 36 37.2856)",
    fill: "#FBA819",
    fillOpacity: 0.9
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 4,
    transform: "matrix(-1 0 0 1 128 37.2856)",
    fill: "#FBA819",
    fillOpacity: 0.6
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 4,
    transform: "matrix(-1 0 0 1 220 37.2856)",
    fill: "#FBA819",
    fillOpacity: 0.2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 4,
    transform: "matrix(-1 0 0 1 59 37.2856)",
    fill: "#FBA819",
    fillOpacity: 0.8
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 4,
    transform: "matrix(-1 0 0 1 151 37.2856)",
    fill: "#FBA819",
    fillOpacity: 0.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 4,
    transform: "matrix(-1 0 0 1 243 37.2856)",
    fill: "#FBA819",
    fillOpacity: 0.1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 4,
    transform: "matrix(-1 0 0 1 82 37.2856)",
    fill: "#FBA819",
    fillOpacity: 0.7
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 4,
    transform: "matrix(-1 0 0 1 174 37.2856)",
    fill: "#FBA819",
    fillOpacity: 0.4
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 4,
    transform: "matrix(-1 0 0 1 266 37.2856)",
    fill: "#FBA819",
    fillOpacity: 0.1
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 4,
    transform: "matrix(-1 0 0 1 289 37)",
    fill: "#FBA819",
    fillOpacity: 0.1
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 4,
    transform: "matrix(-1 0 0 1 312 37)",
    fill: "#FBA819",
    fillOpacity: 0.1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBike2);
export default __webpack_public_path__ + "static/media/Bike 2.06d2873cdbb4e4e7fe02c0a62075c89c.svg";
export { ForwardRef as ReactComponent };